import { render, staticRenderFns } from "./SmsSend.vue?vue&type=template&id=1faa145d"
import script from "./SmsSend.vue?vue&type=script&lang=js"
export * from "./SmsSend.vue?vue&type=script&lang=js"
import style0 from "./SmsSend.vue?vue&type=style&index=0&id=1faa145d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports